module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-navs"
  }, [_c('a', {
    staticClass: "console",
    attrs: {
      "href": "https://console.upyun.com",
      "target": "_blank"
    }
  }, [_vm._v("控制台首页")]), _vm._v(" "), _c('a', {
    staticClass: "profile",
    on: {
      "mouseenter": _vm.mouseEnter,
      "mouseleave": _vm.mouseLeave
    }
  }, [_vm._v("\n        " + _vm._s(_vm.profile.name) + "\n        "), _c('i', {
    staticClass: "el-icon-caret-bottom arrow-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "logout",
    class: {
      show: _vm.showLogout, hide: !_vm.showLogout
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("退出登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.upyun.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../..//assets/logo.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a9084e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/headers.vue
// module id = 453
// module chunks = 24